module.exports = __webpack_public_path__ + "static/media/hl.93941683.svg";